import React from "react";
import {
  AddToMyFlow,
  HashMapItem,
  RemoveFromMyFlow,
  UpdateArtist,
} from "types/MyFlow";
import { ReactElement } from "react";
import { MyFlowState } from "@flow/store/myflow/reducer";
import {
  getVenueNameByID,
  translateItemTypeForNewAPI,
} from "@flow/utils/helperUtils";
import * as myFlowActions from "@flow/store/myflow/actions";
import * as userActions from "@flow/store/user/actions";
import * as favouriteActions from "@flow/store/favourites/actions";
import { withRouteData } from "react-static";
import { connect } from "react-redux";
import {
  Artist,
  ArtistActionButton,
  ArtistContent,
  ArtistEventTime,
  ArtistTitle,
  ArtistVenue,
} from "@flow/scenes/schedule/ui/index";

interface ListActionItemProps {
  item: HashMapItem;
  user: User;
  showVenue?: boolean;
  myFlow: MyFlowState;
  addToMyFlow: (params: AddToMyFlow) => any;
  removeFromMyFlow: (params: RemoveFromMyFlow) => any;
  updateArtist: (params: UpdateArtist) => any;
  saveUserList: () => any;
  staticItem: boolean;
  favourites: Favourite[];
  setFavourites: (params: PutFavouriteRequest) => void;
  addToFavourites: (params: Favourite) => void;
  removeFromFavourites: (params: string) => void;
}

const ListActionItemConnected = ({
  item,
  showVenue = false,
  myFlow,
    user,
  removeFromMyFlow,
  addToMyFlow,
  addToFavourites,
  removeFromFavourites,
  staticItem = false,
}: ListActionItemProps): ReactElement<any> => {
  const {
    title,
    link,
    event: { time, ID, venue_id },
  } = item;

  const itemActive = myFlow.scheduleIdList.indexOf(ID) != -1;

  const toggleItem = () => {
    // handle state changes
    if (itemActive) {
      removeFromMyFlow({ itemId: ID });
    } else {
      addToMyFlow({ itemId: ID });
    }

    // handle server side update
    if (item.events.length > 1) {
      if (itemActive) {
        const otherEvents: string[] = item.events.filter(
          (id) => id !== ID + ""
        );
        const otherEventsNotInFavourites: string[] = otherEvents.filter(
          (otherEventId) => myFlow.scheduleIdList.indexOf(otherEventId) === -1
        );
        if (otherEventsNotInFavourites.length + 1 === item.events.length) {
          removeFromFavourites(item.rootID + "");
        } else {
          otherEventsNotInFavourites.push(ID);
          addToFavourites({
            programId: item.rootID + "",
            type: translateItemTypeForNewAPI(item.type),
            events: item.events || [],
            excludedEvents: otherEventsNotInFavourites,
          });
        }
      } else {
        const otherEvents: string[] = item.events.filter(
          (id) => id !== ID + ""
        );

        addToFavourites({
          programId: item.rootID + "",
          type: translateItemTypeForNewAPI(item.type),
          events: item.events || [],
          excludedEvents: otherEvents.filter(
            (otherEventId) => myFlow.scheduleIdList.indexOf(otherEventId) === -1
          ),
        });
      }
    } else {
      if (itemActive) {
        removeFromFavourites(item.rootID + "");
      } else {
        addToFavourites({
          programId: item.rootID + "",
          type: translateItemTypeForNewAPI(item.type),
          events: item.events || [],
          excludedEvents: [],
        });
      }
    }
    //saveUserList();
  };

  return (
    <Artist className={itemActive ? "item-active" : ""}>
      <ArtistContent>
        <ArtistEventTime className={"artist-event-time"}>
          {time ? time : "tba"}
        </ArtistEventTime>
        <ArtistTitle
          href={link}
          target={"_blank"}
          className={"artist-title-and-venue"}
        >
          {title}
          {showVenue && (
            <ArtistVenue className={"artist-title-and-venue__venue"}>
              {getVenueNameByID(venue_id)}
            </ArtistVenue>
          )}
        </ArtistTitle>
      </ArtistContent>
      {user && !staticItem && (
        <ArtistActionButton
          onClick={toggleItem}
          className={itemActive ? "remove" : "add"}
        />
      )}
    </Artist>
  );
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    addToMyFlow: (params: AddToMyFlow) =>
      dispatch(myFlowActions.addToMyFlow(params)),
    removeFromMyFlow: (params: RemoveFromMyFlow) =>
      dispatch(myFlowActions.removeFromMyFlow(params)),
    addToFavourites: (params: Favourite) =>
      dispatch(favouriteActions.addToFavourites(params)),
    removeFromFavourites: (params: string) =>
      dispatch(favouriteActions.removeFromFavourites(params)),
    //saveUserList: () => dispatch(myFlowAPI.saveUserList()),
    //updateArtist: (params: UpdateArtist) => dispatch(myFlowAPI.updateArtist(params)),
    setFavourites: (params: PutFavouriteRequest) =>
      dispatch(userActions.setFavourites(params)),
  };
};

export const ListActionItem = withRouteData(
  connect(
    (state: any) => ({
      myFlow: state.myFlowReducer,
      favourites: state.user.favorites,
      user: state.auth.user,
    }),
    mapDispatchToProps
  )(ListActionItemConnected)
);



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/scenes/schedule/ui/ListActionItem.tsx